<template>
    <div>
        <Head title="Offers"/>
        <h1 class="mb-8 text-3xl font-bold">Offers</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" @update:model-value="update">
                <label class="block mt-4 text-gray-700">Brand:</label>
                <select v-model="form.brand" class="form-select mt-1 w-full">
                    <option :value="null"/>
                    <option v-for="(id, name) in brands" :value="id">{{ name }}</option>
                </select>
                <label class="block mt-4 text-gray-700">Trashed:</label>
                <select v-model="form.trashed" class="form-select mt-1 w-full">
                    <option :value="null" />
                    <option value="with">With Trashed</option>
                    <option value="only">Only Trashed</option>
                </select>
            </search-filter>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">ID</th>
                    <th class="pb-4 pt-6 px-6">Brand</th>
                    <th class="pb-4 pt-6 px-6">MGMT Offer ID / Plan ID</th>
                    <th class="pb-4 pt-6 px-6">Price</th>
                    <th class="pb-4 pt-6 px-6">Type</th>
                    <th class="pb-4 pt-6 px-6">CreatedAt</th>
                    <th class="pb-4 pt-6 px-6" colspan="2">DeletedAt</th>
                </tr>
                <tr v-for="offer in offers" :key="offer.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                              :href="`/offers/${offer.id}`">
                            {{ offer.id }}
                            <icon v-if="offer.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                            {{ offer.brand_name }}<br>
                            <span class="text-xs">{{offer.brand_id}}</span>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                           Offer ID {{ offer.mgmt_offer_id }} / Plan ID {{offer.mgmt_plan_id}}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                           {{offer.price}}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                            {{offer.type}}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                            {{offer.updated_at}}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" :href="`/offers/${offer.id}`" tabindex="-1">
                            {{offer.deleted_at}}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link class="flex items-center px-4" :href="`/offers/${offer.id}`" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="offers.length === 0">
                    <td class="px-6 py-4 border-t" colspan="12">No offers found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        SearchFilter,
    },
    layout: Layout,
    props: {
        brands: Object,
        filters: Object,
        offers: Array,
    },
    data() {
        return {
            form: {
                brand: this.filters.brand,
                trashed: this.filters.trashed,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/offers', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
